import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { AUTH_EMAIL_SS_KEY, EMAIL_SEARCH_PARAM } from 'src/constants';

export const useSaveEmailFromQuery = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get(EMAIL_SEARCH_PARAM);

  useEffect(() => {
    if (email) {
      sessionStorage.setItem(AUTH_EMAIL_SS_KEY, email);
    }
  }, []);
};
